__turbopack_context__.v({
  "Feature": "chakra-module__1zGeGa__Feature",
  "OldStValue": "chakra-module__1zGeGa__OldStValue",
  "OldValue": "chakra-module__1zGeGa__OldValue",
  "StdValue": "chakra-module__1zGeGa__StdValue",
  "acheiverrank": "chakra-module__1zGeGa__acheiverrank",
  "dateValue": "chakra-module__1zGeGa__dateValue",
  "dayValue": "chakra-module__1zGeGa__dayValue",
  "downloadicon": "chakra-module__1zGeGa__downloadicon",
  "facultyborder1": "chakra-module__1zGeGa__facultyborder1",
  "from": "chakra-module__1zGeGa__from",
  "heading3d": "chakra-module__1zGeGa__heading3d",
  "mbtableheading": "chakra-module__1zGeGa__mbtableheading",
  "monValue": "chakra-module__1zGeGa__monValue",
  "normalbutton": "chakra-module__1zGeGa__normalbutton",
  "pagemaintitle": "chakra-module__1zGeGa__pagemaintitle",
  "paybill": "chakra-module__1zGeGa__paybill",
  "redunderline": "chakra-module__1zGeGa__redunderline",
  "sectiontitle": "chakra-module__1zGeGa__sectiontitle",
  "sectiontitlesub": "chakra-module__1zGeGa__sectiontitlesub",
  "startDate": "chakra-module__1zGeGa__startDate",
  "table1": "chakra-module__1zGeGa__table1",
  "tableheading": "chakra-module__1zGeGa__tableheading",
  "tablepara": "chakra-module__1zGeGa__tablepara",
  "tablescroll": "chakra-module__1zGeGa__tablescroll",
  "tabletitle": "chakra-module__1zGeGa__tabletitle",
  "timeValue": "chakra-module__1zGeGa__timeValue",
  "ulclass": "chakra-module__1zGeGa__ulclass",
  "ulliclass": "chakra-module__1zGeGa__ulliclass",
  "ullispan": "chakra-module__1zGeGa__ullispan",
});
